// Auth configuration
import Vue from 'vue'

export default {

  initAuth(store) {
    Vue.use(require('@websanova/vue-auth'), {
      auth: this.getBearer(),
      http: require('@websanova/vue-auth/drivers/http/vue-resource.1.x.js'),
      router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js')
    })
    this.setAuthOptions(Vue.auth);
    Vue.http.interceptors.push(this.getHttpInterceptor(store))
  },

  setAuthOptions(auth) {
    auth.options.loginData.url = 'users/login'
    auth.options.fetchData.url = 'me'
    auth.options.registerData.url = 'users/register'
    auth.options.refreshData.url = 'users/refresh'
    auth.options.refreshData.interval = 30
    auth.options.refreshData.method = 'POST'
    auth.options.refreshData.enabled = true
    auth.options.authRedirect = auth.options.authRedirect = (function() {
      // We can support hash later if needed. Currently this doesn't appear to be used in any
      // mission critical or substantial functionality.
      const loc = window.location.pathname + '?' + window.location.search;
      // The goal here is to encode the current URL (path) in the page
      // parameter before redirecting. This way, if someone is attempting to
      // visit a page that requires authorization while not being logged in,
      // we can redirect them after login based on this page parameter.
      return window.location.pathname === '/' || window.location.pathname.length < 1 ? '/' : '/' + '?page=' + encodeURI(loc);
    })()
    auth.options.logoutData.redirect = '/'
    auth.options.logoutData.url = 'users/logout'
    auth.options.logoutData.makeRequest = true
    auth.options.impersonateData.url = 'users/impersonate'
    auth.options.impersonateData.redirect = '/dashboard'
    auth.options.rolesVar = 'roles'
    auth.options.unimpersonateData.url = 'users/unimpersonate'
    auth.options.unimpersonateData.redirect = '/dashboard'
    auth.options.unimpersonateData.makeRequest = true
    // google auth
    auth.options.googleData.url = 'users/login_gsso'
    auth.options.googleOauth2Data.params.redirect_uri = function() { return this.options.getUrl(); }
    auth.options.googleOauth2Data.params.clientId = `${process.env.VUE_APP_GOOGLE_SSO_CLIENT_ID}`
    auth.options.googleOauth2Data.clientId = `${process.env.VUE_APP_GOOGLE_SSO_CLIENT_ID}`
    // I'm not convinced we need full, unfettered access to the users' google drive, and the
    // permissions screen is pretty alarming for full access.
    // auth.options.googleOauth2Data.scope = 'email https://www.googleapis.com/auth/drive'
    auth.options.googleOauth2Data.scope = 'email'
  },

  getBearer() {
    return {
      request(req, token) {
        req.headers.set('Authorization', 'Bearer ' + token)
      },
      response(res) {
        let access = (res.body.data || {}).access_token
        if (access) {
          return access
        }
      }
    }
  },

  getHttpInterceptor(store) {
    return (request, next) => {
      next((res) => {
        if (res.status === 401 && ['UnauthorizedAccess', 'InvalidToken'].indexOf(res.data.code) > -1) {
          Vue.auth.logout({
            redirect: {
              path: '/'
            }
          })
        } else if (res.status === 500) {
          console.log(res);
          store.commit("updateMessage", {
            message: "500 Error: Check the console for more details.",
            snackbar: true
          });

          // Vue.router.push({ path: '/500' })
        }
        // automatically displays message from API response.
        // not sure if I want this to be automatic yet.
        if (res.data.message) {
          var message = res.data.message;

          // This will provide more information, which in many cases
          // is important so that users know what caused the error
          // and it may suggest how to correct the issue.
          // (ex: "The email has alrady been taken" appears
          // when a new user is being added but the email being used
          // is not unique.
          if (res.body.errors) {
            for (var key in res.body.errors) {
              var errors = res.body.errors.hasOwnProperty(key) ? res.body.errors[key] : [];

              for (var i = 0; i < errors.length; i++) {
                if (errors[i] && errors[i].length > 0) { message += " " + errors[i]; }
              }
            }
          }

          store.commit("updateMessage", {
            message: message,
            snackbar: true
          });
        }
      })
    }
  }
}
